import {
  assertFeedbackAttachment,
  feedbackFilePayload,
  FeedbackFilePayload,
} from './feedbackFile';

function readAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () =>
      reject(new Error('That file could not be attached.'));
    reader.onload = () => resolve(String(reader.result ?? ''));
    reader.readAsDataURL(file);
  });
}

export function pickFeedbackFile(): Promise<FeedbackFilePayload | null> {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.display = 'none';
    let settled = false;

    const settle = (action: () => void) => {
      if (settled) {
        return;
      }
      settled = true;
      input.remove();
      action();
    };

    input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (!file) {
        settle(() => resolve(null));
        return;
      }
      try {
        assertFeedbackAttachment(file.name.trim(), file.size);
      } catch (error) {
        settle(() => reject(error));
        return;
      }
      readAsDataUrl(file)
        .then(dataUrl => {
          const comma = dataUrl.indexOf(',');
          const fileData = comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
          settle(() =>
            resolve(
              feedbackFilePayload({
                fileName: file.name,
                mimeType: file.type,
                fileSizeBytes: file.size,
                fileData,
              }),
            ),
          );
        })
        .catch(error => settle(() => reject(error)));
    });

    input.addEventListener('cancel', () => settle(() => resolve(null)));
    document.body.appendChild(input);
    input.click();
  });
}
